import type { IconData } from '@stacksjs/iconify-core'

export const moneyBank: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0L0 5v3h1.5v5H0v3h16v-3h-1.5V8H16V5zm3.5 8h-2v5h2zm-5 0h-2v5h2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moneyBank
